'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _objectWithoutProperties2 = require('babel-runtime/helpers/objectWithoutProperties');

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

exports.default = formRadio;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _components = require('components');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function formRadio(props) {
  var input = props.input,
      meta = props.meta,
      type = props.type,
      disabled = props.disabled,
      other = (0, _objectWithoutProperties3.default)(props, ['input', 'meta', 'type', 'disabled']); // eslint-disable-line no-unused-vars

  return _react2.default.createElement(_components.Checkbox, (0, _extends3.default)({}, other, input, { radio: true, disabled: disabled }));
}

formRadio.propTypes = {
  disabled: _propTypes2.default.bool,
  input: _propTypes2.default.object,
  meta: _propTypes2.default.object,
  type: _propTypes2.default.string
};
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/formComponents/formRadio.js
// module id = 2137
// module chunks = 1